const Buffer = () => {
    return (
        <div className="box buffer-screen">
            <div className="head">
                <span className="text-center"/>
                <p className="text-center">
                    <img src="https://www.intogif.com/resource/image/loading/default.gif" title="load" className="loading-gif"/>
                </p>
                <div className="shadow">
                </div>
                <div className="load d-flex justify-content-center">
                    <p>Loading... (this may take a long time)</p>
                </div>
            </div>
        </div>           
    )
}

export default Buffer
